var f = /* @__PURE__ */ ((s) => (s[s.Other = 0] = "Other", s[s.LessonPlan = 1] = "LessonPlan", s[s.Class = 2] = "Class", s[s.Task = 3] = "Task", s[s.Student = 4] = "Student", s[s.StudentWork = 5] = "StudentWork", s[s.Message = 6] = "Message", s[s.RecordAttachment = 10] = "RecordAttachment", s[s.SettingFile = 19] = "SettingFile", s[s.SingleImage = 11] = "SingleImage", s))(f || {});
class I {
  /** Gets the LMS endpoint to hit to get the sas token*/
  static getSasEndpoint(t, i) {
    let e = "";
    switch (t) {
      case 10:
        if (!d(i, ["formId", "id", "fileName", "size"]))
          break;
        e = `lms/api/files/upload/sas/record?formId=${i.formId}&id=${i.id}&fileName=${i.fileName}&size=${i.size}`, i.rowId && (e += `&rowId=${i.rowId}`);
        break;
      case 6:
        if (!d(i, ["messageId", "fileName", "size"]))
          break;
        e = `lms/api/files/upload/sas/message?messageid=${i.messageId}&fileName=${i.fileName}&size=${i.size}`;
        break;
      case 5:
        if (!d(i, ["studentId", "taskId", "fileName", "size"]))
          break;
        e = `lms/api/files/upload/sas/studentwork?studentId=${i.studentId}&taskId=${i.taskId}&fileName=${i.fileName}&size=${i.size}`;
        break;
    }
    if (e == "")
      throw new Error("Could not find sas endpoint to upload");
    return e;
  }
}
const d = (s, t) => !t.some((i) => !s[i]);
export {
  I as AzureUploadArgs,
  f as UploadTypeEnum
};
//# sourceMappingURL=AzureUploadArgs.js.map
